import { normalizeLabelKey } from './friendlyLabels';

export function statusPillClassName(status: unknown): string {
  const normalized = normalizeLabelKey(status);
  if (!normalized || normalized === '—' || normalized === 'UNKNOWN') return 'status-pill status-pill-muted';

  if (
    normalized.includes('FAIL') ||
    normalized.includes('ERROR') ||
    normalized.includes('DECLINED') ||
    normalized.includes('DENIED') ||
    normalized.includes('REJECTED') ||
    normalized.includes('EXPIRED') ||
    normalized.includes('ROLLBACK') ||
    normalized.includes('EXCEEDED') ||
    normalized.includes('BLOCKED')
  ) {
    return 'status-pill status-pill-error';
  }

  if (
    normalized === 'PARTIAL' ||
    normalized.includes('ACTION_REQUIRED') ||
    normalized.includes('ASSESSOR_REVIEW_PENDING') ||
    normalized.includes('REVIEW_PENDING') ||
    normalized.includes('PENDING') ||
    normalized.includes('QUEUED') ||
    normalized.includes('REQUESTED') ||
    normalized.includes('WAITING') ||
    normalized.includes('IN_PROGRESS') ||
    normalized.includes('REQUIRED') ||
    normalized.includes('MISSING')
  ) {
    return 'status-pill status-pill-warning';
  }

  if (
    normalized.includes('RUNNING') ||
    normalized.includes('PROCESSING') ||
    normalized.includes('STARTED') ||
    normalized.includes('BUILD') ||
    normalized.includes('GENERAT') ||
    normalized.includes('VALIDAT') ||
    normalized.includes('WORKFLOW') ||
    normalized.includes('ACTIVITY') ||
    normalized.includes('VIEWED') ||
    normalized.includes('UPDATED') ||
    normalized.includes('SUBMITTED') ||
    normalized.includes('SAVED') ||
    normalized.includes('BASELINE')
  ) {
    return 'status-pill status-pill-info';
  }

  if (
    normalized === 'PASS' ||
    normalized === 'USED' ||
    normalized === 'ENABLED' ||
    normalized.includes('ACTIVE') ||
    normalized.includes('APPROVED') ||
    normalized.includes('READY') ||
    normalized.includes('SUCCESS') ||
    normalized.includes('SUCCEEDED') ||
    normalized.includes('UPLOADED') ||
    normalized.includes('INDEXED') ||
    normalized.includes('REBUILT') ||
    normalized.includes('COMPLETED') ||
    normalized.includes('COMPLETE') ||
    normalized.includes('DELIVERED') ||
    normalized.includes('SENT') ||
    normalized.includes('CREATED') ||
    normalized.includes('GENERATED')
  ) {
    return 'status-pill status-pill-success';
  }

  if (
    normalized.includes('NOT_APPLICABLE') ||
    normalized.includes('N/A') ||
    normalized.includes('DISABLED') ||
    normalized.includes('SKIPPED') ||
    normalized.includes('CANCELLED') ||
    normalized.includes('CANCELED') ||
    normalized.includes('OPTIONAL') ||
    normalized.includes('SUPERSEDED')
  ) {
    return 'status-pill status-pill-muted';
  }

  return 'status-pill status-pill-neutral';
}
